export default __webpack_public_path__ + "static/media/330_business06-es-mobile.f9097763.png";